import React from 'react';
import '../styles/CompFilters.css';
import { CustomSlider, Dropdown, IconButton }  from './';
import { Minus, Plus } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function CompFilters(props) {
    const typeDropdown = props.typeDropdown;
    const setTypeDropdown = props.setTypeDropdown;
    const selectedType = props.selectedType;
    const setSelectedType = props.setSelectedType;
    const distance = props.distance;
    const setDistance = props.setDistance;
    const recencyMonths = props.recencyMonths;
    const setRecencyMonths = props.setRecencyMonths;
    const selectedConditions = props.selectedConditions;
    const applyFilters = props.applyFilters;
    const bedsDifference = props.bedsDifference;
    const setBedsDifference = props.setBedsDifference;
    const bathsDifference = props.bathsDifference;
    const setBathsDifference = props.setBathsDifference;
    const sqftDifference = props.sqftDifference;
    const setSqftDifference = props.setSqftDifference;
    const yearBuiltDifference = props.yearBuiltDifference;
    const setYearBuiltDifference = props.setYearBuiltDifference;

    const savedDifferences = {
        beds: bedsDifference,
        baths: bathsDifference,
        sqft: sqftDifference,
        yearBuilt: yearBuiltDifference
    };

    const typeOptions = [
        {
            label: "Sold",
            value: "sold",
            selected: selectedType.includes("sold") ? true : false
        },
        {
            label: "Pending",
            value: "pending",
            selected: selectedType.includes("pending") ? true : false
        },
        {
            label: "For sale",
            value: "for-sale",
            selected: selectedType.includes("for-sale") ? true : false
        }
    ];

    const similarityOptions = [
        {
            label: "Beds",
            value: bedsDifference,
            setValue: setBedsDifference,
            increment: 1
        },
        {
            label: "Baths",
            value: bathsDifference,
            setValue: setBathsDifference,
            increment: 1
        },
        {
            label: "Sqft",
            value: sqftDifference,
            setValue: setSqftDifference,
            increment: 100
        },
        {
            label: "Year built",
            value: yearBuiltDifference,
            setValue: setYearBuiltDifference,
            increment: 5
        }
    ];

    const typeLabel = selectedType.length === 3 ? "All" : selectedType.length === 1 ? typeOptions.filter(item => item.value === selectedType[0])[0].label : "Multiple";

    const toggleTypeDropdown = () => {
        setTypeDropdown(!typeDropdown);
    };

    const changeCompType = async(item) => {
        const typeIndex = selectedType.indexOf(item.value);
        const newTypeArray = [...selectedType]
        if ( typeIndex === -1 ) {
            newTypeArray.push(item.value);
            setSelectedType(newTypeArray);
        } 
        else {
            newTypeArray.splice(typeIndex, 1);
            setSelectedType(newTypeArray);
        };

        applyFilters(newTypeArray, distance, recencyMonths, savedDifferences, selectedConditions);
    };

    const onChangeDistanceSlider = (event, value) => {
        setDistance(value);

        applyFilters(selectedType, value, recencyMonths, savedDifferences, selectedConditions);
    };

    const onChangeRecencySlider = (event, value) => {
        setRecencyMonths(value);

        applyFilters(selectedType, distance, value, savedDifferences, selectedConditions);
    };
    
    const subtractFunc = (item, index) => {
        if ( item.value <= 0 ) {
            item.setValue(null);
            newDifferences(index, null);
        }
        else {
            const newVal = item.value - item.increment; 
            item.setValue(newVal);
            newDifferences(index, newVal);
        }
    };

    const plusFunc = (item, index) => {
        const newVal = item.value + item.increment;
        item.setValue(newVal);
        newDifferences(index, newVal);
    };

    const newDifferences = (index, val) => {
        const clone = structuredClone(savedDifferences);
        if ( index === 0 ) {
            clone.beds = val;
        }
        else if ( index === 1 ) {
            clone.baths = val;
        }
        else if ( index === 2 ) {
            clone.sqft = val;
        }
        else {
            clone.yearBuilt = val;
        }
        applyFilters(selectedType, distance, recencyMonths, clone, selectedConditions);
    }

    return (
        <div className="comp-filters-outer-container">
            <div className="comp-filters-left-container">
                <Dropdown
                    open={typeDropdown}
                    icon={null}
                    label={typeLabel}
                    disabled={false}
                    options={typeOptions}
                    multiselect={true}
                    toggleDropdown={toggleTypeDropdown}
                    cta={(item) => changeCompType(item)}
                    sidealign={"left"}
                    topalign={"bottom"}
                    indexSelect={false}
                    selectedIndex={null}
                />
                <div className="comp-filters-distance-slider">
                    <h3 className="body-bold colour-primary">
                        Distance ({distance} mi)
                    </h3>
                    <CustomSlider
                        disabled={false}
                        value={distance}
                        label=""
                        onChange={onChangeDistanceSlider}
                        min={0.25}
                        max={10}
                        step={0.25}
                    />
                </div>
                <div className="comp-filters-distance-slider">
                    <h3 className="body-bold colour-primary">
                        Recency ({recencyMonths} months)
                    </h3>
                    <CustomSlider
                        disabled={false}
                        value={recencyMonths}
                        label=""
                        onChange={onChangeRecencySlider}
                        min={1}
                        max={12}
                        step={1}
                    />
                </div>
                {
                    similarityOptions.map((item, index) =>
                        <div 
                            className="comp-filters-similarity-element"
                            key={index}
                        >
                            <span className="body-bold colour-primary">
                                ±{item.label}
                            </span>
                            <div className="comp-filters-similarity-row">
                                <IconButton
                                    size="medium"
                                    icon={<Minus fill={colour.gray07} className="" />}
                                    disabled={false}
                                    clickFunc={() => subtractFunc(item, index)}
                                    standardIcon={false}
                                    background={true}
                                    bgType={"white"}
                                    contextTooltip={false}
                                    contextTooltipBG={null}
                                    contextTooltipText={null}
                                    customClass={null}
                                />
                                <div className="comp-filters-similarity-value">
                                    <span className="body-regular colour-primary">
                                        {item.value === null ? "N/A" :  item.value}
                                    </span>
                                </div>
                                <IconButton
                                    size="medium"
                                    icon={<Plus fill={colour.gray07} className="" />}
                                    disabled={false}
                                    clickFunc={() => plusFunc(item, index)}
                                    standardIcon={false}
                                    background={true}
                                    bgType={"white"}
                                    contextTooltip={false}
                                    contextTooltipBG={null}
                                    contextTooltipText={null}
                                    customClass={null}
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
};

export default CompFilters;